export enum MsgType {
    Diferencia_horas_ausencias = 1,
    Licencias = 2,
    Descuentos_Retenciones  = 3,
    Otras_consultas_recibo  = 4
}

// Claves de traducción de los motivos históricos (consultas anteriores a los motivos configurables)
export const MsgTypeLabels: Record<MsgType, string> = {
    [MsgType.Diferencia_horas_ausencias]: 'fileDocuments.fileDocumentQuery.msgType.hoursAbsencesDifference',
    [MsgType.Licencias]: 'fileDocuments.fileDocumentQuery.msgType.leaves',
    [MsgType.Descuentos_Retenciones ]: 'fileDocuments.fileDocumentQuery.msgType.discountsWithholdings',
    [MsgType.Otras_consultas_recibo ]: 'fileDocuments.fileDocumentQuery.msgType.otherPayslipQueries'
};

export interface QueryDocument {
    id?: string;
    documentId: number;
    documentationName: string;
    ouId: number;
    creationDate?: Date | string;
    message: string;
    messageType: MsgType | string;
    userId: number;
    userName?: string;
    userMail?: string;
    readed?: boolean;
    closed?: boolean;
    isDeleted?: boolean;
  }
